import { useCreateDamageExceptionNote } from '@/api/DamageExceptions';
import { DamageExceptionNoteModel } from '@/types';
import { timeConverter } from '@/utils/helpers';
import { Alert, Button, Divider, Input, Timeline } from 'antd';
import React, { FC, useState } from 'react';

interface NotesProps {
  damageExceptionId: number;
  notes: DamageExceptionNoteModel[];
}
export const Notes: FC<NotesProps> = ({ damageExceptionId, notes }) => {
  const [note, setNote] = useState<string>();
  const [error, setError] = useState<string>();
  const { mutateAsync: createNoteAsync, isPending: noteLoading } =
    useCreateDamageExceptionNote(damageExceptionId);

  const onAddNote = async () => {
    setError(undefined);
    if (!note) return;
    const res = await createNoteAsync({ damageExceptionId, note });
    if (!res.success) {
      setError(res.message.Message);
      return;
    }
    setNote(undefined);
    setError(undefined);
  };

  return (
    <>
      <Divider>Notes</Divider>
      <Timeline
        mode="left"
        items={notes.map((note) => ({
          color: 'green',
          children: (
            <>
              <p>{`${timeConverter(note.createdAt)} 【${note.createdBy}】 wrote:`}</p>
              <div>{note.note}</div>
            </>
          ),
        }))}
      />
      <Input.TextArea
        rows={3}
        value={note}
        onChange={(e) => setNote(e.target.value)}
      />
      {error ? <Alert message={error} type="error" className="mt-2" /> : null}
      <div className="text-end mt-2">
        <Button
          type="primary"
          disabled={!note || note.length === 0}
          loading={noteLoading}
          onClick={onAddNote}
        >
          Add Note
        </Button>
      </div>
    </>
  );
};
